(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rfs-navigation"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.rfs-navigation').forEach((nav) => {
    const toggles = [...nav.querySelectorAll('.rfs-navigation__toggle')];
    const setOpen = (toggle, open) => {
      toggle.setAttribute('aria-expanded', String(open));
      document.getElementById(toggle.getAttribute('aria-controls')).hidden = !open;
    };
    toggles.forEach((toggle) => toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggles.forEach((other) => setOpen(other, other === toggle && open));
    }));
    nav.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const active = toggles.find((toggle) => toggle.getAttribute('aria-expanded') === 'true');
      if (active) { setOpen(active, false); active.focus(); event.stopPropagation(); }
    });
    document.addEventListener('click', (event) => {
      if (!nav.contains(event.target)) toggles.forEach((toggle) => setOpen(toggle, false));
    });
    nav.addEventListener('focusout', (event) => {
      if (!nav.contains(event.relatedTarget)) toggles.forEach((toggle) => setOpen(toggle, false));
    });
  });
  } catch(e) { console.error(e); }
})();

})();
